const voiceFileExtensions = new Set(['aac', 'caf', 'm4a', 'mp3', 'ogg', 'opus', 'wav', 'webm']);

export const nativeVoiceAccept = 'audio/*,.m4a,.aac,.mp3,.wav,.caf,.ogg,.opus,.webm';

export function isVoiceAudioFile(file: Pick<File, 'name' | 'type'>): boolean {
  if (file.type.startsWith('audio/')) return true;
  const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
  return file.type === '' && voiceFileExtensions.has(extension);
}

export function requiresLocalhostMicrophone(input: {
  secureContext: boolean;
  hostname: string;
  finePointer: boolean;
}): boolean {
  return (
    !input.secureContext &&
    !['localhost', '127.0.0.1'].includes(input.hostname) &&
    input.finePointer
  );
}

export function secureLanMicrophoneUrl(input: {
  protocol: string;
  hostname: string;
}): string | null {
  if (input.protocol !== 'http:' || ['localhost', '127.0.0.1'].includes(input.hostname)) {
    return null;
  }
  return `https://${input.hostname}:8443/`;
}
